/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPORGANISATIONWITHHOLDINGTAXDECLARATION = {
    Both: 'DR',
    ExemptionParagraph: 'EWT',
    ReducedRate: 'RR'
} as const;
export type IAPORGANISATIONWITHHOLDINGTAXDECLARATION = typeof IAPORGANISATIONWITHHOLDINGTAXDECLARATION[keyof typeof IAPORGANISATIONWITHHOLDINGTAXDECLARATION];


export function IAPORGANISATIONWITHHOLDINGTAXDECLARATIONFromJSON(json: any): IAPORGANISATIONWITHHOLDINGTAXDECLARATION {
    return IAPORGANISATIONWITHHOLDINGTAXDECLARATIONFromJSONTyped(json, false);
}

export function IAPORGANISATIONWITHHOLDINGTAXDECLARATIONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPORGANISATIONWITHHOLDINGTAXDECLARATION {
    return json as IAPORGANISATIONWITHHOLDINGTAXDECLARATION;
}

export function IAPORGANISATIONWITHHOLDINGTAXDECLARATIONToJSON(value?: IAPORGANISATIONWITHHOLDINGTAXDECLARATION | null): any {
    return value as any;
}

